import React from 'react'
import { useTranslation } from 'react-i18next'
import ReactApexChart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'

interface ChartData {
  labels: string[]
  series: number[]
}

interface DashboardProps {
  data: ChartData
}

const GeneralDashboard = ({ data }: DashboardProps) => {
  const { t } = useTranslation()

  const chartOptions: ApexOptions = {
    chart: {
      type: 'donut',
    },
    labels: data.labels,
    colors: ['#ff9f31', '#f47524'],
    plotOptions: {
      pie: {
        donut: {
          labels: {

            show: true,
            total: {
              show: true,
              fontSize: '16px',
              label: 'Total',
              formatter: (w) => {
                return `${w.config.series.reduce((a: number, b: number) => {
                  return a + b
                }, 0)}`
              },
            },
          },
        },
      },
    },
    legend: {
      show: false,
    },

  }

  chartOptions.dataLabels = {
    style: {
      colors: ['#212121'],
      fontWeight: 'normal',
      fontSize: '16px',

    },
  
  }

  return (
    <>
      <div className='column-dashboard pb-4'>
        <span
          className='title py-4 text-left'
          dangerouslySetInnerHTML={{
            __html: `${t('INTERACTIONS_BY_REFERRAL')}`,
          }}
        />
        <div className='container-button-rounded'>
          <label className='button-rounded-secondary'></label>
          <span className='mx-2 title'>{`${t('LINKS')}`}</span>
          {/* <span className='mx-2 title-bold'>{data.series[0]}</span> */}
        </div>
        <div className='container-button-rounded'>
          <label className='button-rounded-primary'></label>
          <span className='mx-2 title'>{`${t('QR_CODES')}`}</span>
          {/* <span className='mx-2 title-bold'>{data.series[1]}</span> */}
        </div>
      </div>
      <div className='column-dashboard container-grafico-general'>
        <ReactApexChart
          options={chartOptions}
          series={data.series}
          type='donut'
        />
      </div>
    </>
  )
}

export default GeneralDashboard
